/**
 * User Form Validation Schema
 * Using Zod for type-safe validation
 */

import { z } from 'zod';
import { UserStatus } from '../../types/domain-enums';

export const userFormSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid email address'),
  fullName: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be less than 100 characters'),
  companyId: z
    .string()
    .min(1, 'Company is required'),
  username: z
    .string()
    .optional()
    .refine(
      (val) => !val || val.length >= 3,
      'Username must be at least 3 characters if provided'
    ),
  password: z
    .string()
    .optional()
    .refine(
      (val) => !val || val.length >= 8,
      'Password must be at least 8 characters if provided'
    ),
  department: z
    .string()
    .optional(),
  jobTitle: z
    .string()
    .optional(),
  employeeId: z
    .string()
    .optional(),
  phoneNumber: z
    .string()
    .optional()
    .refine(
      (val) => !val || /^[\d\s\-\+\(\)]+$/.test(val),
      'Invalid phone number format'
    ),
  status: z
    .nativeEnum(UserStatus)
    .default(UserStatus.ACTIVE),
  timezone: z
    .string()
    .default('UTC'),
  language: z
    .string()
    .default('en'),
});

export type UserFormData = z.infer<typeof userFormSchema>;
